// necessary "hacks" from new People vue tab to temporarily prevent classic to break
import { check as checkFF } from '@webapp-next/lib/feature-flag';
import getEmployeeCollection from './facades/get-employee-collection';
import userSession from '@webapp-next/lib/user-session';
import { getRouter } from '@webapp-next/router/helpers';
import { PAY_RULE_ENUM } from './definitions';
import EVENTS from './events';
import { isEnterprise } from '@webapp-next/lib/company-subscription';
import useRootStore from '@/modules/people/store/root';

export default function peopleGlobalRetroFeed() {
  if (checkFF('ptp-0-people-module-vue')) {
    if (window.DP?.desktop?.team) {
      window.DP.desktop.team = dtTeam;
    }

    window.$dtteam = dtTeam;
  }
}

const dtTeam = {
  PAY_RULE_ENUM,
};

// employee collection
dtTeam.clcEmployee = {
  get: function dtTeamClcEmployeeGet(id) {
    return getEmployeeCollection().find(({ EmpId }) => EmpId === id);
  },
  askServer: function dtTeamClcAskServer(props, cb) {
    cb();
  },
};

// TODO: strong candidates to get removed
dtTeam.vwProfileModal = {
  $el: {
    height: function dtTeamVwProfileModal$elHeight() {
      return 100;
    },
  },
};

// TODO: do we need to implement this?
// dtTeam.blnCanAdmin = false;
// dtTeam.blnCanJournal = false;

// TODO: do we need to implement this?
dtTeam.bootstrap = function dtTeamBootstrap(mixSetup) {
  // console.log('#### dtTeam.bootstrap', mixSetup);
  // dtTeam.blnCanAdmin = !!mixSetup.CanAdmin;
  // dtTeam.blnCanJournal = !!mixSetup.CanJournal;

  // TODO: feed the rootState.setup here?
  return true;
};

dtTeam.searchTeam = function dtTeamSearchTeam(string) {
  return;
};

dtTeam.viewEmployee = function dtTeamViewEmployee(employeeId) {
  const route =
    userSession().Me.EmployeeId === employeeId
      ? '#profile'
      : `#team/${employeeId}/personal`;

  getRouter().push(route);
  return true;
};

dtTeam.rtrTM = {
  navigate: function dtTeamRtrTMNavigate(route) {
    getRouter().push(route);
  },
};

// TODO: change this implementation
dtTeam.printTime = function(dtTime) {
  const { DefaultShortTimeFormat } = userSession();
  let strTime = '';
  const obj24HPattern = /^[HG]/;

  if (obj24HPattern.test(DefaultShortTimeFormat)) {
    strTime = dtTime.print(DefaultShortTimeFormat);
  } else {
    strTime = dtTime.print('g');
    const strMinutes = dtTime.print('i');

    if (strMinutes != '00') {
      strTime += ':' + strMinutes;
    }

    strTime += dtTime.print('a');
  }
  return strTime;
};

// TODO: do we need to implement those?
// function isEmployeeSubordinate(mixEmployee) {
//
//   var blnIsSubordinate = false;
//   var mdlEmployee = null;
//   var mdlEmployeeInTeam = null;
//   if ((mdlEmployee = this.getEmployee(mixEmployee)) && (mdlEmployeeInTeam = this.clcEmployee.get(mdlEmployee.get('Id')))) blnIsSubordinate = mdlEmployeeInTeam.get('IsSubordinate');
//
//   return blnIsSubordinate;
// }
// dtTeam.canJournalEmployee = function(mdlEmployee) {
//   console.log('#### dtTeam.canJournalEmployee', mdlEmployee);
//   let blnCanJournal = false;
//
//   if (
//     isNotFree() &&
//     dtTeam.blnCanJournal &&
//     // userSession
//     mdlEmployee.Id !== userSession().Me.UserId &&
//     isEmployeeSubordinate(mdlEmployee)
//   ) {
//     let mdlRole = this.clcRole.get(mdlEmployee.get('Role'));
//     if (mdlRole.get('Id') != $dtteam.ACCESS_ENUM.ADMIN || dtTeam.blnCanAdmin) {
//       blnCanJournal = true;
//     }
//   }
//
//   return blnCanJournal;
// };

/*
  // retro-feed for create new emp form schedule
  DP.root().desktop.team.addEmployee(
    $re.vwQuickAdd.fnHandleSaveNewEmployee, // callback function
    $re.vwQuickAdd, // context ??
    $re.intCompanyId, // location id
    strEmpName // employee name
  );
*/
dtTeam.addEmployee = function addEmployee(cb) {
  if (!checkFF('cjs-423-quick-edit-in-enterprise') && isEnterprise()) {
    getRouter().push('#enterprise_team_add');
    return;
  }

  getRouter().push('#team/add');

  VueEventBus.$once(EVENTS.PEOPLE_FORM_ADD_CLOSE, employee => {
    if (cb && employee) {
      try {
        cb(employee.Id, employee);
      } catch (e) {
        console.error(e);
      }
    }
  });
};

// TODO: this function will rely on the store exposed global variable,
// TODO: we cant import the store here because it breaks compilation
dtTeam.blnCanMakeAnnouncement = function getPermissionCanMakeAnnouncement() {
  const rootState = useRootStore();
  return !!rootState.getModulePermission('CanMakeAnnouncement');
};
